import React, { Component } from "react";
import { Route, Routes } from "react-router-dom";

import "./index.scss";
import LadderDetail from "./detail";
import LadderList from "./list";
import LadderTarget from "./target";

export default class Ladder extends Component {
	render() {
		return (
			<div className="ladder-component clearfix">
				<Routes>
					<Route exact path="/" element={<LadderList />} />
					<Route exact path="/ladder" element={<LadderList />} />
					<Route path="/ladder/detail" element={<LadderDetail />} />
					<Route path="/ladder/list" element={<LadderList />} />
					<Route path="/ladder/target" element={<LadderTarget />} />
					<Route element={<LadderList />} />
				</Routes>
			</div>
		);
	}
}